import { api } from '@/lib/api';
import type { AdoptionDetailsRequest, AdoptionDetailsResponse } from './types';

const URL = '/vendor/onboarding/module-details/adoption';

export async function save_adoption_details(
  input: AdoptionDetailsRequest,
): Promise<AdoptionDetailsResponse> {
  const res = await api.post<AdoptionDetailsResponse>(URL, input);
  return res.data;
}

export async function fetch_adoption_details(): Promise<AdoptionDetailsResponse | null> {
  const res = await api.get<AdoptionDetailsResponse | null>(URL);
  return res.data;
}
